import { ComponentProps } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";
import { SelectMultiple } from "../SelectMultiple";

type SelectMultipleProps = Omit<
  ComponentProps<typeof SelectMultiple>,
  "values" | "onChange"
>;

interface FormSelectMultipleProps<TFieldValues extends FieldValues>
  extends SelectMultipleProps {
  name: UseControllerProps<TFieldValues>["name"];
  control: UseControllerProps<TFieldValues>["control"];
}

const FormSelectMultiple = <TFieldValues extends FieldValues>({
  name,
  control,
  ...props
}: FormSelectMultipleProps<TFieldValues>) => {
  const { field, fieldState } = useController({ name, control });
  return (
    <SelectMultiple {...props} {...field} error={fieldState.error?.message} />
  );
};

export { FormSelectMultiple };
